import { WebpageSchema } from "@/data/schemas";

const CommonSchema = () => {
  return (
    <>
      <script
        id="webpage-schema"
        type="application/ld+json"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(WebpageSchema),
        }}
      />
    </>
  );
};

export default CommonSchema;
